import AnimeCard from "@/components/feature/AnimeCard";
import { animeList } from "@/mocks/anime";

export default function LatestSection() {
  const latest = [...animeList].sort((a, b) => (a.status === "更新中" ? -1 : 1)).slice(0, 8);

  return (
    <section className="container-site py-10 md:py-14">
      <div className="mb-6">
        <h2 className="flex items-center gap-2 font-heading text-2xl text-foreground-50 md:text-3xl">
          <i className="ri-refresh-line text-accent-500" />
          最新更新
        </h2>
        <p className="mt-1 text-sm text-foreground-400">追番不迷路，每周同步更新集数</p>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 md:gap-4">
        {latest.map((a) => (
          <AnimeCard key={a.id} anime={a} />
        ))}
      </div>
    </section>
  );
}